export default "__VITE_ASSET__TMJEEY6m__"